import { __awaiter } from '../../_virtual/_tslib.js';
import { useQueryClient, useInfiniteQuery } from 'react-query';
import { getInfiniteQueryCurrentDataLength } from '../utils/getInfiniteQueryCurrentDataLength.js';
import { validateAndConvertReqParamToInt } from '../utils/validateAndConvertReqParamToNum.js';
import { getAuthIdParam } from '../../methods/getAuthIdParam.js';
import { getArrayWithType } from '../../methods/getArrayWithType.js';
import API from '../const.js';
import { getAuthHeader } from '../utils/getAuthHeader.js';
import { QueryNames } from './queryNames.js';
import { BID_STATUS } from '../../constants/bidStatus.js';
import 'react';
import 'react-router';
import '../../constants/authorizedUsers.js';
import '../../constants/bulkLoadCardStatus.js';
import '../../constants/misc.js';
import '../../constants/event-names.js';
import '../../constants/eventsMapObj.js';
import '../../constants/Faq.js';
import '../../constants/languages.js';
import '../../constants/loadStatus.js';
import '../../constants/lorryStatus.js';
import '../../constants/lorryTypes.js';
import '../../constants/mostSearchedLinks.js';
import '../../constants/Pages.js';
import '../../constants/serviceTypeId.js';
import '../../constants/StateList.js';
import '../../constants/bidUpdateType.js';
import '../../constants/userAction.js';
import '../../constants/api.js';
import '../../constants/link.js';
import '../../constants/market.js';
import '../../constants/payment.js';
import '../../constants/admin/screenId.js';
import 'bowser';
import '../../components/toast/toast.js';
import '../auth.service.js';
import 'react-cookie';
import '../../methods/formatDate.js';
import '../../methods/getTransporterFigure.js';
import '../../methods/getDownloadsFigure.js';
import 'lodash.isequal';
import '../../methods/getPageLoadSourceUTMParam.js';
import { arrayAddIf } from '../../methods/common.js';
import 'crypto-js';
import 'react-router-dom';
import '../../app-context.js';
import '../city-search.service.js';
import { useCsDashboard } from '../../hooks/useCsDashboard.js';
import 'next/router';

function useGetLoadsForCurrentUserQuery({ companyId, status, lorryType, request_type, created_at_string, type, id, bulkId, preload = [] }, { enabled, refetchInterval, onSuccess }) {
    const queryClient = useQueryClient();
    const { isCsDashboardUser } = useCsDashboard();
    const { data, fetchNextPage, hasNextPage, isFetching, isLoading, refetch } = useInfiniteQuery([QueryNames.loadsForCurrentUser], ({ pageParam = 1 }) => __awaiter(this, void 0, void 0, function* () {
        const validatedCompanyId = validateAndConvertReqParamToInt("companyId", companyId);
        if (!validatedCompanyId) {
            return { results: [], next: undefined };
        }
        const response = yield fetch(API.ALL_LOADS + getAuthIdParam(), {
            body: JSON.stringify({
                company_id: validatedCompanyId,
                page_number: pageParam,
                status,
                request_type,
                created_at_string,
                type,
                id,
                bulk_id: bulkId,
                preload: ["load_details", ...preload],
                bid_status: getArrayWithType([
                    BID_STATUS.WAITING,
                    BID_STATUS.IN_TRANSIT,
                    BID_STATUS.UNVERIFIED,
                    BID_STATUS.COMPLETED,
                    BID_STATUS.STAND_BY,
                    BID_STATUS.PARTIALLY_ACCEPTED,
                    ...arrayAddIf(isCsDashboardUser, [BID_STATUS.EXPIRED])
                ], String)
            }),
            method: "POST",
            headers: Object.assign({ Accept: "application/json", "Content-Type": "application/json" }, getAuthHeader())
        });
        if (response.status === 401) {
            // this will cause the AuthVerifyComp to re-render and when token verification fails, logout the app
            queryClient.invalidateQueries(QueryNames.validateToken);
        }
        if (!response.ok) {
            throw new Error("Problem fetching data");
        }
        const dataFromServer = (yield response.json()).data;
        const loads = lorryType
            ? dataFromServer.all.filter((d) => d.lorry_id === lorryType)
            : dataFromServer.all;
        const data = {
            results: loads,
            totalCount: dataFromServer.total_count,
            next: dataFromServer.page_number < dataFromServer.total_pages
                ? dataFromServer.page_number + 1
                : undefined
        };
        return data;
    }), {
        getNextPageParam: (lastPage) => lastPage.next,
        refetchInterval: refetchInterval || false,
        enabled,
        onSuccess
    });
    return {
        data,
        fetchNextPage,
        hasNextPage,
        currentDataLength: getInfiniteQueryCurrentDataLength(data),
        isFetching,
        isLoading,
        refetch
    };
}

export { useGetLoadsForCurrentUserQuery };
//# sourceMappingURL=useGetLoadsForCurrentUserQuery.js.map
